// document.addEventListener("DOMContentLoaded", function() {
//     // Function to show the popup
//     function showPopup(message) {
//         const popup = document.getElementById('favorites-popup');
//         const messageElement = document.getElementById('popup-message');
//         messageElement.textContent = message;
//         popup.style.display = 'flex'; // Show the popup
//     }

//     // Function to hide the popup
//     function hidePopup() {
//         const popup = document.getElementById('favorites-popup');
//         popup.style.display = 'none'; // Hide the popup
//     }

//     // Event listener for the close button
//     document.querySelector('.close-popup').addEventListener('click', hidePopup);

//     // Function to add a product to favorites
//     function addToFavorites(product) {
//         const favorites = JSON.parse(localStorage.getItem('favoritesProducts')) || [];
        
//         // Log the current favorites
//         console.log("Current Favorites:", favorites);

//         // Check if the product ID is valid
//         if (!product.id) {
//             console.error("Product ID is missing.");
//             return;
//         }

//         // Log the product being added
//         console.log("Adding Product to Favorites:", product);

//         // Check if the product is already in favorites
//         if (!favorites.some(item => item.id === product.id)) {
//             favorites.push(product);
//             localStorage.setItem('favoritesProducts', JSON.stringify(favorites));
//             showPopup(`${product.title} has been added to your favorites!`);
//         } else {
//             showPopup(`${product.title} is already in your favorites.`);
//         }
//     }

//     // Event listener for the "Add to Favorite" badge
//     document.querySelectorAll('.badge--add-to-favorite').forEach(badge => {
//         badge.addEventListener('click', function(e) {
//             e.preventDefault(); // Prevent default anchor behavior

//             // Get product data from data attributes
//             const product = {
//                 id: this.getAttribute('data-product-id'),
//                 title: this.getAttribute('data-product-title'),
//                 image: this.getAttribute('data-product-image'),
//                 sku: this.getAttribute('data-product-sku'),
//                 price: this.getAttribute('data-product-price'),
//                 inventory: this.getAttribute('data-product-inventory'),
//                 handle: this.getAttribute('data-product-handle'),
//                 variantId: this.getAttribute('data-variant-id') // Ensure this attribute exists
//             };

//             // Log the product data
//             console.log("Product Data from Badge:", product);

//             // Add product to favorites
//             addToFavorites(product);
//         });
//     });
// });
// New Updated code for add to Favorites Starts //
document.addEventListener("DOMContentLoaded", function () {
    const UOM_OPTION_NAMES = [
        "uom",
        "unit of measure",
        "unit of measurement"
    ];

    function showPopup(message) {
        const popup = document.getElementById("favorites-popup");
        const messageElement = document.getElementById("popup-message");

        if (!popup || !messageElement) {
            console.warn(message);
            return;
        }

        messageElement.textContent = message;
        popup.style.display = "flex";
    }

    function hidePopup() {
        const popup = document.getElementById("favorites-popup");

        if (popup) {
            popup.style.display = "none";
        }
    }

    document.querySelector(".close-popup")?.addEventListener("click", hidePopup);

    function getFavorites() {
        try {
            const favorites = JSON.parse(
                localStorage.getItem("favoritesProducts") || "[]"
            );

            return Array.isArray(favorites) ? favorites : [];
        } catch (error) {
            console.error("Unable to read favourites:", error);
            return [];
        }
    }

    function readProductVariantData(badge) {
        const productContainer = badge.closest(
            '[data-favorite-product], [id^="ProductInfo-"]'
        );
        const dataElement = productContainer?.querySelector(
            '.favorite-product-data, script[id^="FavoriteProductData-"]'
        );

        if (!dataElement) {
            return null;
        }

        try {
            const productData = JSON.parse(dataElement.textContent);

            if (!Array.isArray(productData.variants)) {
                return null;
            }

            return productData;
        } catch (error) {
            console.error("Unable to read product variants:", error);
            return null;
        }
    }

    function getUomOptionIndex(optionNames) {
        if (!Array.isArray(optionNames)) {
            return -1;
        }

        return optionNames.findIndex(function (optionName) {
            return UOM_OPTION_NAMES.includes(
                String(optionName).trim().toLowerCase()
            );
        });
    }

    function normalizeValue(value) {
        return String(value || "").trim().toLowerCase();
    }

    function getProductContainer(badge) {
        return badge.closest(
            '[data-favorite-product], [id^="ProductInfo-"]'
        );
    }

    function getSelectedOptionValues(badge) {
        const productContainer = badge.closest(
            '[data-favorite-product], [id^="ProductInfo-"]'
        );
        const variantPicker = productContainer?.querySelector(
            "variant-selects, variant-radios"
        );

        if (!variantPicker) {
            return [];
        }

        const values = [];
        const fieldsets = variantPicker.querySelectorAll("fieldset");

        fieldsets.forEach(function (fieldset) {
            const checkedInput = fieldset.querySelector(
                'input[type="radio"]:checked'
            );

            if (checkedInput) {
                values.push(checkedInput.value);
            }
        });

        variantPicker.querySelectorAll("select").forEach(function (select) {
            values.push(select.value);
        });

        if (values.length === 0) {
            variantPicker
                .querySelectorAll('input[type="radio"]:checked')
                .forEach(function (input) {
                    values.push(input.value);
                });
        }

        return values;
    }

    function findSelectedVariant(badge, productData) {
        const selectedOptions = getSelectedOptionValues(badge);

        if (selectedOptions.length > 0) {
            const optionMatch = productData.variants.find(function (variant) {
                if (!Array.isArray(variant.options)) {
                    return false;
                }

                if (variant.options.length !== selectedOptions.length) {
                    return false;
                }

                return variant.options.every(function (option, index) {
                    return normalizeValue(option) ===
                        normalizeValue(selectedOptions[index]);
                });
            });

            if (optionMatch) {
                return optionMatch;
            }
        }

        const productContainer = getProductContainer(badge);
        const variantInput = productContainer?.querySelector(
            'form[action*="/cart/add"] input[name="id"], input[name="id"]'
        );

        if (variantInput?.value) {
            const formMatch = productData.variants.find(function (variant) {
                return String(variant.id) === String(variantInput.value);
            });

            if (formMatch) {
                return formMatch;
            }
        }

        const urlVariantId = new URL(window.location.href)
            .searchParams.get("variant");

        if (urlVariantId) {
            const urlMatch = productData.variants.find(function (variant) {
                return String(variant.id) === String(urlVariantId);
            });

            if (urlMatch) {
                return urlMatch;
            }
        }

        return productData.variants.find(function (variant) {
            return String(variant.id) === String(badge.dataset.variantId || "");
        }) || null;
    }

    function buildFavoriteVariant(badge) {
        const productData = readProductVariantData(badge);

        if (productData) {
            const uomOptionIndex = getUomOptionIndex(productData.options);
            const selectedVariant = findSelectedVariant(badge, productData);

            if (selectedVariant) {
                const uom = uomOptionIndex >= 0 && Array.isArray(selectedVariant.options)
                    ? selectedVariant.options[uomOptionIndex] || ""
                    : "";

                return {
                    id: badge.dataset.productId || "",
                    title: badge.dataset.productTitle || "Product",
                    image: selectedVariant.image || badge.dataset.productImage || "",
                    sku: selectedVariant.sku || "",
                    price: selectedVariant.price || "",
                    inventory: selectedVariant.inventory ?? "",
                    handle: badge.dataset.productHandle || "",
                    variantId: String(selectedVariant.id || ""),
                    uom: uom
                };
            }
        }

        /* Fallback for favourite buttons that expose only one variant. */
        return {
            id: badge.dataset.productId || "",
            title: badge.dataset.productTitle || "Product",
            image: badge.dataset.productImage || "",
            sku: badge.dataset.productSku || "",
            price: badge.dataset.productPrice || "",
            inventory: badge.dataset.productInventory || "",
            handle: badge.dataset.productHandle || "",
            variantId: String(badge.dataset.variantId || ""),
            uom: badge.dataset.productUom || ""
        };
    }

    function isSameVariant(savedItem, product) {
        return (
            String(savedItem.variantId || "") ===
                String(product.variantId || "") &&
            normalizeValue(savedItem.uom) === normalizeValue(product.uom)
        );
    }

    function addSelectedVariantToFavorites(badge) {
        const favorites = getFavorites();
        const product = buildFavoriteVariant(badge);

        if (!product.id || !product.variantId || !product.uom) {
            showPopup("Please select a valid UOM before adding this product.");
            return;
        }

        const alreadyExists = favorites.some(function (savedItem) {
            return isSameVariant(savedItem, product);
        });

        if (alreadyExists) {
            showPopup(
                `${product.title}${product.uom ? ` (${product.uom})` : ""} ` +
                "is already in your favourites."
            );
            return;
        }

        favorites.push(product);

        try {
            localStorage.setItem(
                "favoritesProducts",
                JSON.stringify(favorites)
            );

            showPopup(
                `${product.title}${product.uom ? ` (${product.uom})` : ""} ` +
                "has been added to your favourites!"
            );
        } catch (error) {
            console.error("Unable to save favourites:", error);
            showPopup("Unable to save these products. Please try again.");
        }
    }

    document.addEventListener("click", function (event) {
        const badge = event.target.closest(".badge--add-to-favorite");

        if (!badge) {
            return;
        }

        event.preventDefault();
        addSelectedVariantToFavorites(badge);
    });
});
// New Updated code for add to Favorites Ends //